import { useMemo } from 'react'
import {
  getAvailabilityReasonForConsole,
  useIsAvailableDebounced,
  UseIsNameAvailable,
} from '@aserto/console-common'

import { useIsConfigurationInstanceNameAvailable } from '../../api/internal'

const useIsConfigurationNameAvailable = (): UseIsNameAvailable =>
  useMemo(() => {
    const useIsConfigurationNameAvailableInternal = (name: string, defaultName: string) => {
      const queryResult = useIsConfigurationInstanceNameAvailable(name, {
        enabled: name !== defaultName,
      })

      const response = useMemo(() => {
        const isAvailable =
          !queryResult?.data?.availability ||
          queryResult?.data?.availability === 'NAME_AVAILABILITY_AVAILABLE'

        return {
          isAvailable: isAvailable,
          reason: getAvailabilityReasonForConsole(queryResult?.data?.reason),
        }
      }, [queryResult?.data])

      return response
    }

    const useIsConfigurationNameAvailableDebounced = (key: string, defaultkey: string) => {
      const useRunTarget = () => useIsAvailableDebounced(useIsConfigurationNameAvailableInternal)
      const run = useMemo(useRunTarget, [])
      return run(key, defaultkey)
    }
    return useIsConfigurationNameAvailableDebounced
  }, [])

export default useIsConfigurationNameAvailable
